import { Button } from '@/_shared/components/ui/button';
import { Callout } from '@/_shared/components/ui/callout';
import { useRudderstackSignInAgain } from '@/_shared/hooks/useRudderstackSignInAgain';
import { RUDDERSTACK_REAUTH_ACTION, RUDDERSTACK_REAUTH_MESSAGE } from '@/_shared/lib/rudderstack-reauth';

/** The in-place form of "Sign in again" (ACT2-1124, F12), for a surface that shows its errors in a callout. */
export function RudderstackReauthCallout(): React.ReactElement {
  const signIn = useRudderstackSignInAgain();
  return (
    <Callout variant="error">
      <p>{RUDDERSTACK_REAUTH_MESSAGE}</p>
      <div className="mt-2">
        <Button
          type="button"
          variant="secondary"
          size="md"
          label={RUDDERSTACK_REAUTH_ACTION}
          loading={signIn.pending || signIn.isLoading}
          onClick={signIn.start}
        />
      </div>
    </Callout>
  );
}
